export default __webpack_public_path__ + "static/media/bcaf.d5d54546.png";